import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/ai-and-agents/reasoning/reasoning.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
